module.exports = __webpack_public_path__ + "static/media/icon-heart-red.ca748f63.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon-heart-red.svg
// module id = 1884
// module chunks = 0